<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Marketing Digital</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Marketing digital que convierte atención en <span class="highlight-green">crecimiento</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Estrategias para atraer tráfico, captar clientes y generar resultados medibles.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> SEO y optimización de contenido</li>
          <li><i class="bi bi-check-circle-fill"></i> Publicidad en buscadores y redes sociales</li>
          <li><i class="bi bi-check-circle-fill"></i> Analítica y seguimiento de conversiones</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-graph-up-arrow"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-search"></i>
          </div>
          <h4 class="modern-service-card-title">SEO Estratégico</h4>
          <p>Optimizamos tu presencia en buscadores para atraer tráfico de calidad y mejorar tu posicionamiento
            orgánico.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-google"></i>
          </div>
          <h4 class="modern-service-card-title">Campañas SEM / PPC</h4>
          <p>Maximizamos visibilidad inmediata con campañas optimizadas para intención, conversión y retorno.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-megaphone"></i>
          </div>
          <h4 class="modern-service-card-title">Social Media Ads</h4>
          <p>Llegamos a tu cliente ideal con segmentación avanzada y anuncios diseñados para generar acción.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Estrategia personalizada para cada objetivo</li>
          <li><i class="bi bi-check-circle-fill"></i> Creatividad orientada a resultados</li>
          <li><i class="bi bi-check-circle-fill"></i> Transparencia y medición durante todo el proceso</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Impulsa tu presencia digital con campañas diseñadas para generar crecimiento real.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
